import { render, staticRenderFns } from "./SitemapLink.vue?vue&type=template&id=17bd528c&scoped=true&lang=pug&"
import script from "./SitemapLink.vue?vue&type=script&lang=js&"
export * from "./SitemapLink.vue?vue&type=script&lang=js&"
import style0 from "./SitemapLink.vue?vue&type=style&index=0&id=17bd528c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bd528c",
  null
  
)

export default component.exports